import { useEffect, useState } from "react";
import axios from "axios";
import { Appid, BaseUrl, Imei, LoginTypeID, SerialNo, Version } from "../../enum/enum";
import { useLoader } from "../../context/loaderContext";
import { useAuth } from "../../context/authContext";
import Layout from "../../layout/layout";
import moment from "moment";
import { useLocation } from "react-router-dom";

const IncomeReport = () => {
    const { showLoader, hideLoader } = useLoader();
    const {
        token,
        sessionId,
        userId,
    } = useAuth();
    const location = useLocation();
    const { opId } = location.state;

    const [incomeReport, setIncomeReport] = useState([]);
    const [levelList, setLevelList] = useState([]);
    const [level, setLevel] = useState("0");
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");
    const [incomeTypeName, setIncomeTypeName] = useState("");
    // const [fromUser, setFromUser] = useState("");

    const getLevelList = async () => {
        try {
            const url = `${BaseUrl}Dashboard/BindLevel`;

            const obj = {
                "appSession": {
                    "appid": Appid,
                    "imei": Imei,
                    "loginTypeID": LoginTypeID,
                    "regKey": "",
                    "serialNo": SerialNo,
                    "session": token,
                    "sessionID": sessionId,
                    "uid": 0,
                    "userID": userId,
                    "version": Version
                },
                "request": opId || 9402
            }

            showLoader();

            const res = await axios.post(url, obj);

            if (res.data?.statuscode == 1) {
                setLevelList(res.data.data || []);
            }

            hideLoader();
        } catch (e) {
            hideLoader();
            console.log(e.message);
        }
    }

    const getIncomeReport = async () => {
        try {
            const url = `${BaseUrl}App/GetIncomeWiseReport`;

            const obj = {
                "FromDate": fromDate ? moment(fromDate).format("DD-MMM-YYYY") : moment(new Date(), "DD-MMM-YYYY").format("DD-MMM-YYYY"),
                "LevelNo": level.toString(),
                "OPID": opId || 9402,
                "ToDate": toDate ? moment(toDate).format("DD-MMM-YYYY") : moment(new Date(), "DD-MMM-YYYY").format("DD-MMM-YYYY"),
                "incomeCategoryID": 1,
                "isSeller": false,
                "appid": Appid,
                "imei": Imei,
                "loginTypeID": LoginTypeID,
                "regKey": "",
                "serialNo": SerialNo,
                "session": token,
                "sessionID": sessionId,
                "uid": 0,
                "userID": userId,
                "version": Version
            }

            showLoader();

            const res = await axios.post(url, obj);

            if (res.data?.statuscode == 1) {
                setIncomeReport(res.data.incomeWiseReport || []);
            }

            hideLoader();
        } catch (e) {
            hideLoader();
            console.log(e.message);
        }
    }

    useEffect(() => {
        getLevelList();
        getIncomeReport();

        let incomeName = '';
        if (opId == 9425) {
            incomeName = 'Salary';
        } else if (opId == 9412) {
            incomeName = 'ROI';
        } else if (opId == 9424) {
            incomeName = 'Dynamic';
        } else if (opId == 9401) {
            incomeName = 'Direct';
        } else {
            incomeName = '';
        }
        setIncomeTypeName(incomeName);
    }, []);

    return (
        <Layout>
            <main>
                <div className="pageWrapper maxWidth pt-0">
                    <div className="container-fluid income-report-main">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="desktop-card card">
                                    <div className="card-header mb-3">
                                        <h5> {incomeTypeName} Income Report </h5>
                                    </div>
                                    {/* filters */}
                                    {/* {incomeReport?.length > 0 && ( */}
                                    <div className="mx-md-3 mx-0 table-filter"
                                        style={{
                                            display: 'grid',
                                            gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
                                            gap: '16px'
                                        }}
                                    >
                                        <div>
                                            <label className="form-label">From Date</label>
                                            <input
                                                type="date"
                                                className="form-control"
                                                value={fromDate || moment(new Date()).format(("YYYY-MM-DD"))}
                                                onChange={(e) => setFromDate(e.target.value)}
                                            />
                                        </div>
                                        <div>
                                            <label className="form-label">To Date</label>
                                            <input
                                                type="date"
                                                className="form-control"
                                                value={toDate || moment(new Date()).format(("YYYY-MM-DD"))}
                                                min={fromDate}
                                                onChange={(e) => setToDate(e.target.value)}
                                            />
                                        </div>
                                        <div>
                                            <label className="form-label">Level</label>
                                            <div className="dropdown">
                                                <button className="form-select" type="button" data-bs-toggle="dropdown">
                                                    {(level == '0' ? 'All' : level) || "Select Level"}
                                                </button>
                                                <ul className="dropdown-menu" style={{ maxHeight: "200px", overflowY: "auto", width: "-webkit-fill-available" }}>
                                                    <li><span className="dropdown-item" onClick={() => setLevel("0")}>All</span></li>
                                                    {
                                                        levelList?.map((lev) => (
                                                            <li key={lev.levelNo}>
                                                                <span className="dropdown-item" onClick={() => setLevel(lev.levelNo)}>
                                                                    {lev.levelNo}
                                                                </span>
                                                            </li>
                                                        ))
                                                    }
                                                </ul>
                                            </div>

                                        </div>
                                        {/* <div>
                                            <label className="form-label">From User</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="From User..."
                                                value={fromUser}
                                                onChange={(e) => setFromUser(e.target.value)}
                                            />
                                        </div> */}
                                        <div className="d-flex-end">
                                            <button
                                                type="button"
                                                onClick={getIncomeReport}
                                                className="cus-btn-submit"
                                            >Search</button>
                                        </div>
                                    </div>
                                    {/* // )} */}
                                    {/* records */}
                                    <div className="desktop-view-only card-body px-0">
                                        {
                                            incomeReport?.length > 0 ? (
                                                <div className="table-responsive">
                                                    <table className="table align-middle mb-0 bg-hover-effect">
                                                        <thead>
                                                            <tr>
                                                                <th scope="col">#</th>
                                                                <th scope="col">Txn Id</th>
                                                                <th scope="col">From User</th>
                                                                <th scope="col">Package Amount</th>
                                                                <th scope="col">Income Name</th>
                                                                <th scope="col">Income</th>
                                                                {/* <th scope="col">Laps Income</th> */}
                                                                <th scope="col">Admin Charge</th>
                                                                <th scope="col">Level No.</th>
                                                                {/* <th scope="col">Left Business</th>
                                                                <th scope="col">Right Business</th>
                                                                <th scope="col">Matching Business</th> */}
                                                                <th scope="col">Entry Date</th>
                                                                <th scope="col">Payout Date</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {
                                                                incomeReport?.map((el, i) => (
                                                                    <tr key={i}>
                                                                        <td>{i + 1}</td>
                                                                        <td>{el.tid}</td>
                                                                        <td>{el.fromName}</td>
                                                                        <td>${el.packageAmount}</td>
                                                                        <td>{el.incomeName}</td>
                                                                        <td>${el.creditedAmount}</td>
                                                                        {/* <td>{el.lapsIncome}</td> */}
                                                                        <td>{el.adminCharge}</td>
                                                                        <td>{el.levelNo}</td>
                                                                        {/* <td>{el.totalLeftBusiness}</td>
                                                                        <td>{el.totalRightBusiness}</td>
                                                                        <td>{el.todayMatchBusiness}</td> */}
                                                                        <td>{el.entryDate}</td>
                                                                        <td>{el.payoutDate}</td>
                                                                    </tr>
                                                                ))
                                                            }
                                                        </tbody>
                                                    </table>
                                                </div>
                                            ) : (
                                                <div>
                                                    <p className="text-center">No records found.</p>
                                                </div>
                                            )}
                                    </div>
                                    <div className="mobile-view-only mt-3">
                                        {incomeReport?.length > 0 ? (
                                            incomeReport.map((el, i) => (
                                                <div key={i} className="card mb-3 p-3 bg-hover-effect rounded shadow-sm">
                                                    <div className="d-flex justify-content-between align-items-center my-2">
                                                        <span className="badge bg-dark">#{i + 1}</span>
                                                        <span className="small">{el.entryDate}</span>
                                                    </div>

                                                    <div className="d-flex justify-content-between align-items-center my-1">
                                                        <strong>Txn Id:</strong>
                                                        <p className="mb-0 f-w-500">{el.tid}</p>
                                                    </div>
                                                    <div className="d-flex justify-content-between align-items-center my-1">
                                                        <strong>From User:</strong>
                                                        <p className="mb-0 f-w-500">{el.fromName}</p>
                                                    </div>
                                                    <div className="d-flex justify-content-between align-items-center my-1">
                                                        <strong>Package Amt:</strong>
                                                        <p className="mb-0 f-w-500">${el.packageAmount}</p>
                                                    </div>
                                                    <div className="d-flex justify-content-between align-items-center my-1">
                                                        <strong>Income Name:</strong>
                                                        <p className="mb-0 f-w-500">{el.incomeName}</p>
                                                    </div>
                                                    <div className="d-flex justify-content-between align-items-center my-1">
                                                        <strong>Income:</strong>
                                                        <p className="mb-0 f-w-500">${el.creditedAmount}</p>
                                                    </div>
                                                    {/* <div className="d-flex justify-content-between align-items-center my-1">
                                                        <strong>Laps Income:</strong>
                                                        <p className="mb-0 f-w-500">{el.lapsIncome}</p>
                                                    </div> */}
                                                    <div className="d-flex justify-content-between align-items-center my-1">
                                                        <strong>Admin Charge:</strong>
                                                        <p className="mb-0 f-w-500">{el.adminCharge}</p>
                                                    </div>
                                                    <div className="d-flex justify-content-between align-items-center my-1">
                                                        <strong>Level No.:</strong>
                                                        <p className="mb-0 f-w-500">{el.levelNo}</p>
                                                    </div>
                                                    {/* <div className="d-flex justify-content-between align-items-center my-1">
                                                        <strong>Left Business:</strong>
                                                        <p className="mb-0 f-w-500">{el.totalLeftBusiness}</p>
                                                    </div>
                                                    <div className="d-flex justify-content-between align-items-center my-1">
                                                        <strong>Right Business:</strong>
                                                        <p className="mb-0 f-w-500">{el.totalRightBusiness}</p>
                                                    </div>
                                                    <div className="d-flex justify-content-between align-items-center my-1">
                                                        <strong>Matching Business:</strong>
                                                        <p className="mb-0 f-w-500">{el.todayMatchBusiness}</p>
                                                    </div> */}
                                                    <div className="d-flex justify-content-between align-items-center my-1">
                                                        <strong>Payout Date:</strong>
                                                        <p className="mb-0 f-w-500">{el.payoutDate}</p>
                                                    </div>
                                                </div>
                                            ))
                                        ) : (
                                            <p className="text-center">No records found.</p>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </Layout >
    )
}

export default IncomeReport;